import React, { useEffect, useState } from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import { UserService } from '../../Pages/Users/User.service'
import { AlertType, classBorderLabelDark, classInput, classInputDark, classLabel, classLabelDark } from '../../Utils/Types'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { ModalAlert } from '../Modal/modalAlert'
import { changeDark } from '../Redux/userSlice'
import { useDispatch } from 'react-redux'
import { MenuService } from './MenuService'
import { ToolTips } from '../ToolTips/tooltips'
import { Funcoes } from '../../Utils/Funcoes'

type Props = {
    styleConfig: (tema: string, hoverMenu: string, hoverSubMenu: string, corBarra: string) => void,
    styleLogo: (urlLogo: string) => void,
}

export const MenuConfig = ({ styleConfig, styleLogo }: Props) => {

    const dispatch = useDispatch()

    const [corTema, setCorTema]                     = useState("")
    const [tema, setTema]                           = useState(localStorage.getItem('@ecommerce/tema') || "light")
    const [corHoverMenu, setCorHoverMenu]           = useState('')
    const [corHoverSubMenu, setCorHoverSubMenu]     = useState('')
    const [corBarra, setCorBarra]                   = useState('')

    const [corTemaCopy, setCorTemaCopy]                 = useState("")
    const [corHoverMenuCopy, setCorHoverMenuCopy]       = useState("")
    const [corHoverSubMenuCopy, setCorHoverSubMenuCopy] = useState("")
    const [corBarraCopy, setCorBarraCopy]               = useState("")
    const [idVariacaoCopy, setIdVariacaoCopy]           = useState("")
    const [variacaoCopy, setVariacaoCopy]               = useState("")
    const [subVariacaoCopy, setSubVariacaoCopy]         = useState("")

    const [visible, setVisible]             = useState(false)
    const [message, setMessage]             = useState("")
    const [messageType, setMessageType]     = useState<AlertType>("DANGER")

    const [idVariacao, setIdVariacao]       = useState("")
    const [variacao, setVariacao]           = useState("")
    const [subVariacao, setSubVariacao]     = useState("")

    const [idJuros, setIdJuros]     = useState("")
    const [juros, setJuros]         = useState("0")
    const [diasJuros, setDiasJuros]         = useState("")

    //const [terminal, setTerminal] = useState("")

    const [loading, setLoading]                     = useState(false)
    const [loadingLogo, setLoadingLogo]             = useState(false)
    const [loadingClearLogo, setLoadingClearLogo]   = useState(false)

    const getConfig = async () => {

        try {

            const attr = await UserService.FindConfig()

            if (attr.error) {

                localStorage.removeItem('@ecommerce/idVariacao')
                localStorage.removeItem('@ecommerce/desc_variacao')
                localStorage.removeItem('@ecommerce/desc_sub_variacao')

                localStorage.removeItem('@ecommerce/idJuros')
                localStorage.removeItem('@ecommerce/taxa_juros')
                localStorage.removeItem('@ecommerce/diasJuros')
                
            } else {

                setIdVariacao(attr.data.config.id?.toString())
                setVariacao(attr.data.config.desc_variacao)
                setSubVariacao(attr.data.config.desc_sub_variacao)

                setIdJuros(attr.data.juros.id?.toString())
                setJuros(attr.data.juros.taxa_juros)
                setDiasJuros(attr.data.juros.dias)

                localStorage.setItem('@ecommerce/idVariacao', attr.data.config.id?.toString())
                localStorage.setItem('@ecommerce/desc_variacao', attr.data.config.desc_variacao)
                localStorage.setItem('@ecommerce/desc_sub_variacao', attr.data.config.desc_sub_variacao)

                localStorage.setItem('@ecommerce/idJuros', attr.data.juros.id?.toString())
                localStorage.setItem('@ecommerce/taxa_juros', attr.data.juros.taxa_juros)
                localStorage.setItem('@ecommerce/diasJuros', attr.data.juros.dias)

            }

        } catch {
            
            setVisible(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao carregar as configurações do sistema")
        }

    }

    useEffect(() => {
        const tema = localStorage.getItem('@ecommerce/cor_tema') || 'bg-blue-600'
        const bgMenu = localStorage.getItem('@ecommerce/cor_bg_menu') || 'hover:bg-blue-700'
        const bgNav = localStorage.getItem('@ecommerce/cor_bg_nav') || 'hover:bg-blue-800'
        const barra = localStorage.getItem('@ecommerce/cor_barra') || 'scrollbar-thumb-blue-800'

        setCorTema(tema)
        setCorHoverMenu(bgMenu)
        setCorHoverSubMenu(bgNav)
        setCorBarra(barra)

        setCorTemaCopy(tema)
        setCorHoverMenuCopy(bgMenu)
        setCorHoverSubMenuCopy(bgNav)
        setCorBarraCopy(barra)

        setIdVariacaoCopy(localStorage.getItem('@ecommerce/idVariacao') || '')
        setVariacaoCopy(localStorage.getItem('@ecommerce/desc_variacao') || '')
        setSubVariacaoCopy(localStorage.getItem('@ecommerce/desc_sub_variacao') || '')

        getConfig()

    }, [])

    const variacaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVariacao(e.target.value)
    }

    const subVariacaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSubVariacao(e.target.value)
    }

    const jurosChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setJuros(Funcoes.MaskMoney(e.target.value))
    }

    const diasJurosChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDiasJuros(e.target.value.replace(/[^0-9]/g, ''))
    }

    /*
    const terminalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTerminal(e.target.value)
    }
    useEffect(() => {

        //localStorage.setItem('@ecommerce/cor_tema', corTema)
        //localStorage.setItem('@ecommerce/cor_bg_menu', corHoverMenu)
        //localStorage.setItem('@ecommerce/cor_bg_nav', corHoverSubMenu)

        //localStorage.setItem('@ecommerce/idVariacao', idVariacao.toString())
        //localStorage.setItem('@ecommerce/desc_variacao', variacao)
        //localStorage.setItem('@ecommerce/desc_sub_variacao', subVariacao)

        setCorTemaCopy(localStorage.getItem('@ecommerce/cor_tema') || '')
        setCorHoverMenuCopy(localStorage.getItem('@ecommerce/cor_bg_menu') || '')
        setCorHoverSubMenuCopy(localStorage.getItem('@ecommerce/cor_bg_nav') || '')
        setCorBarraCopy(localStorage.getItem('@ecommerce/cor_barra') || '')

        setIdVariacaoCopy(localStorage.getItem('@ecommerce/idVariacao') || '')
        setVariacaoCopy(localStorage.getItem('@ecommerce/desc_variacao') || '')
        setSubVariacaoCopy(localStorage.getItem('@ecommerce/desc_sub_variacao') || '')

    }, [corTema, corHoverMenu, corHoverSubMenu, corBarra, variacao, subVariacao, idVariacao])

    */

    const handleButtonClick = async (bgColor: any, hoverMenuColor: any, hoverSubMenuColor: any, corBarra: any) => {

        setCorTema(bgColor)
        setCorHoverMenu(hoverMenuColor)
        setCorHoverSubMenu(hoverSubMenuColor)
        setCorBarra(corBarra)

        styleConfig(bgColor, hoverMenuColor, hoverSubMenuColor, corBarra)

    }

    const handleSalvarConfigVariacao = async () => {

        let varia = {
            desc_variacao: variacao,
            desc_sub_variacao: subVariacao,
            id: idVariacao
        }

        const resp = await UserService.SaveVariacao(varia)

        if (resp.error === true) {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(resp.msg || '')

            return false

        } else {

            setIdVariacao(resp.id?.toString() || "0")

            localStorage.setItem('@ecommerce/idVariacao', resp.id?.toString() || "0")
            localStorage.setItem('@ecommerce/desc_variacao', varia.desc_variacao || '')
            localStorage.setItem('@ecommerce/desc_sub_variacao', varia.desc_sub_variacao || '')

            return true

        }
    }

    const handleSalvarConfigJuros = async () => {

        let taxas = {
            taxa_juros: juros,
            dias: diasJuros,
            id: idJuros
        }

        const resp = await UserService.SaveJuros(taxas)

        if (resp.error === true) {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(resp.msg || '')
            return false

        } else {

            setIdJuros(resp.id?.toString() || "0")

            localStorage.setItem('@ecommerce/idJuros', resp.id?.toString() || "0")
            localStorage.setItem('@ecommerce/taxa_juros', taxas.taxa_juros || '')
            localStorage.setItem('@ecommerce/diasJuros', taxas.dias || '')
            return true
        }
    }

    const handleSalvarConfig = async () => {

        let theme = {
            tema: tema,
            cor_tema: corTema,
        }

        const resp = await UserService.SaveTema(theme)

        if (resp.error === true) {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(resp.msg || '')

            return false
        } else {

            localStorage.setItem(`@ecommerce/tema`, tema)
            localStorage.setItem('@ecommerce/cor_tema', corTema)
            localStorage.setItem('@ecommerce/cor_bg_menu', corHoverMenu)
            localStorage.setItem('@ecommerce/cor_bg_nav', corHoverSubMenu)
            localStorage.setItem('@ecommerce/cor_barra', corBarra)

            return true

        }
    }

    const handleSave = async () => {

        setVisible(false)

        setLoading(true)
        const resultSalvarVaria = await handleSalvarConfigVariacao()
        const resultSalvarJuros = await handleSalvarConfigJuros()
        const resultSalvarCorTema = await handleSalvarConfig()
        setLoading(false)

        if (resultSalvarVaria && resultSalvarJuros && resultSalvarCorTema) {
            setVisible(true)
            setMessageType("SUCCESS")
            setMessage("Configurações salvas com sucesso!")

            toggleConfig()
        }
    }

    const bt_um         = () => handleButtonClick('bg-slate-600', 'hover:bg-slate-700', 'hover:bg-slate-800', 'scrollbar-thumb-slate-800')
    const bt_dois       = () => handleButtonClick('bg-gray-600', 'hover:bg-gray-700', 'hover:bg-gray-800', 'scrollbar-thumb-gray-800')
    const bt_tres       = () => handleButtonClick('bg-zinc-600', 'hover:bg-zinc-700', 'hover:bg-zinc-800', 'scrollbar-thumb-zinc-800')
    const bt_quatro     = () => handleButtonClick('bg-red-600', 'hover:bg-red-700', 'hover:bg-red-800', 'scrollbar-thumb-red-800')
    const bt_cinco      = () => handleButtonClick('bg-orange-600', 'hover:bg-orange-700', 'hover:bg-orange-800', 'scrollbar-thumb-orange-800')
    const bt_seis       = () => handleButtonClick('bg-amber-600', 'hover:bg-amber-700', 'hover:bg-amber-800', 'scrollbar-thumb-amber-800')
    const bt_sete       = () => handleButtonClick('bg-yellow-600', 'hover:bg-yellow-700', 'hover:bg-yellow-800', 'scrollbar-thumb-yellow-800')
    const bt_oito       = () => handleButtonClick('bg-lime-600', 'hover:bg-lime-700', 'hover:bg-lime-800', 'scrollbar-thumb-lime-800')
    const bt_nove       = () => handleButtonClick('bg-green-600', 'hover:bg-green-700', 'hover:bg-green-800', 'scrollbar-thumb-green-800')
    const bt_dez        = () => handleButtonClick('bg-emerald-600', 'hover:bg-emerald-700', 'hover:bg-emerald-800', 'scrollbar-thumb-emerald-800')
    const bt_onze       = () => handleButtonClick('bg-teal-600', 'hover:bg-teal-700', 'hover:bg-teal-800', 'scrollbar-thumb-teal-800')
    const bt_doze       = () => handleButtonClick('bg-cyan-600', 'hover:bg-cyan-700', 'hover:bg-cyan-800', 'scrollbar-thumb-cyan-800')
    const bt_treze      = () => handleButtonClick('bg-sky-600', 'hover:bg-sky-700', 'hover:bg-sky-800', 'scrollbar-thumb-sky-800')
    const bt_quatorze   = () => handleButtonClick('bg-blue-600', 'hover:bg-blue-700', 'hover:bg-blue-800', 'scrollbar-thumb-blue-800')
    const bt_quinze     = () => handleButtonClick('bg-indigo-600', 'hover:bg-indigo-700', 'hover:bg-indigo-800', 'scrollbar-thumb-indigo-800')
    const bt_dezesseis  = () => handleButtonClick('bg-violet-600', 'hover:bg-violet-700', 'hover:bg-violet-800', 'scrollbar-thumb-violet-800')
    const bt_dezessete  = () => handleButtonClick('bg-purple-600', 'hover:bg-purple-700', 'hover:bg-purple-800', 'scrollbar-thumb-purple-800')
    const bt_dezoito    = () => handleButtonClick('bg-fuchsia-600', 'hover:bg-fuchsia-700', 'hover:bg-fuchsia-800', 'scrollbar-thumb-fuchsia-800')
    const bt_dezenove   = () => handleButtonClick('bg-pink-600', 'hover:bg-pink-700', 'hover:bg-pink-800', 'scrollbar-thumb-pink-800')
    const bt_vinte      = () => handleButtonClick('bg-rose-600', 'hover:bg-rose-700', 'hover:bg-rose-800', 'scrollbar-thumb-rose-800')

    const handleAbrirModalAlert = () => {

        setVisible(false)

        let modal = document.getElementById('modal_alert')
        let modalContent = document.getElementById('modal_content_alert')

        if (modal) {
            modal.style.visibility = 'visible'

            if (modalContent) {
                modalContent.classList.remove('mt-[-400px]')
                modalContent.classList.add('mt-24')
            }
        }

        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            divPerfil.classList.add('hidden')
        }

    }

    const toggleConfig = () => {

        if (tema !== localStorage.getItem("@ecommerce/tema") || corTema !== localStorage.getItem("@ecommerce/cor_tema") ||
            variacao !== localStorage.getItem("@ecommerce/desc_variacao") || subVariacao !== localStorage.getItem("@ecommerce/desc_sub_variacao")) {

            handleAbrirModalAlert()

        } else {

            let divMenuConfig = document.getElementById('menu_config') as HTMLDivElement

            if (divMenuConfig) {

                if (divMenuConfig.classList.contains('-right-96')) {

                    divMenuConfig.classList.remove('-right-96')
                    divMenuConfig.classList.add('right-6')

                } else {

                    divMenuConfig.classList.add('-right-96')
                    divMenuConfig.classList.remove('right-6')


                }
            }
        }
    }

    const restaurarConfig = () => {

        styleConfig(corTemaCopy, corHoverMenuCopy, corHoverSubMenuCopy, corBarraCopy)
        setCorTema(corTemaCopy)
        setCorHoverMenu(corHoverMenuCopy)
        setCorHoverSubMenu(corHoverSubMenuCopy)
        setIdVariacao(idVariacaoCopy)
        setVariacao(variacaoCopy)
        setSubVariacao(subVariacaoCopy)

        const divHTML_APP = document.getElementById('html_app') as HTMLElement | null

        const temaSalvo = localStorage.getItem('@ecommerce/tema') || 'light' // Defina o valor padrão como 'light'

        if (divHTML_APP) {
            // Aplique a classe conforme o tema
            divHTML_APP.classList.toggle('dark', temaSalvo === 'dark')

            // Defina o estado do tema
            setTema(temaSalvo)
            dispatch(changeDark(temaSalvo))
        }

        const divMenuConfig = document.getElementById('menu_config') as HTMLDivElement | null

        if (divMenuConfig) {
            // Usando toggle para alternar entre as classes
            divMenuConfig.classList.toggle('-right-96')
            divMenuConfig.classList.toggle('right-6')
        }

    }

    const restaurarImagePadrao = async () => {

        setLoadingClearLogo(true)
        const retApi = await MenuService.ClearImage()
        setLoadingClearLogo(false)

        if (retApi.error) {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(retApi.msg || '')

            return

        } else {
            styleLogo('')
            localStorage.setItem("imageLogo", '')
        }

    }

    const toggleLight = () => {

        let divHTML_APP = document.getElementById('html_app') as HTMLElement

        if (divHTML_APP) {

            if (divHTML_APP.classList.contains('dark')) {

                divHTML_APP.classList.remove('dark')
                setTema("light")
                dispatch(changeDark('light'))

            }
        }
    }

    const toggleDark = () => {

        let divHTML_APP = document.getElementById('html_app') as HTMLElement

        if (divHTML_APP) {

            if (!divHTML_APP.classList.contains('dark')) {

                divHTML_APP.classList.add('dark')
                setTema("dark")
                dispatch(changeDark('dark'))
            }
        }
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    // ------------------------------------------------------------- LOGO ----------------------------------------------------------------------------------------------
    const handleSelectImage = () => {
        const inputSelectImage = document.getElementById('inputSelectImageLogo') as HTMLInputElement
        if (inputSelectImage) {
            inputSelectImage.click()
        }
    }

    const handleChangeInputImage = async (e: React.ChangeEvent<HTMLInputElement>) => {

        setVisible(false)

        if (e.target.files && e.target.files.length > 0) {

            setLoadingLogo(true)
            const retApi = await MenuService.AddImage(e.target.files[0])
            setLoadingLogo(false)

            const input = document.getElementById('inputSelectImageLogo') as HTMLInputElement

            if (input) {
                //console.log('input ', input)
                input.value = ''
            }

            if (retApi.error) {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(retApi.msg || '')

                return

            } else {
                styleLogo(retApi.url_logo || '')
                localStorage.setItem("imageLogo", retApi.url_logo || '')
            }
        }
    }

    // ---------------------------------------------------------------- USEEFFECT DE ALTURA --------------------------------------------------------------
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerHeight <= 750)

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerHeight <= 750)
        }

        window.addEventListener('resize', handleResize)

        // Limpeza do event listener ao desmontar o componente
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])


    const buttonLigth   = tema === 'light' ? `${corTema} ${corHoverMenu} text-white` : 'bg-transparent hover:bg-slate-600 text-black dark:text-white'
    const buttonDark    = tema === 'dark' ? `${corTema} ${corHoverMenu} text-white` : 'bg-transparent hover:bg-slate-300 text-black'

    return (

        <div>
            <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

            <div id='menu_config' className={`w-[300px] sm:w-[380px] h-[90%]  overflow-auto -right-96 rounded-md flex flex-col bg-white dark:bg-slate-500
                     border dark:border-slate-800 overflow-y-auto shadow-md shadow-slate-400 duration-300 dark:shadow-slate-800 fixed pb-4 z-10 ${isSmallScreen ? 'my-10 lg:-my-6' : ''}`}>

                <div className={`pt-4 pl-4 pr-4 flex flex-col`}>

                    <div className={`flex flex-row`}>
                        <span className={`font-semibold dark:text-slate-100 transition-colors duration-700`}>Configurações</span>

                        <button tabIndex={-1} onClick={toggleConfig}>
                            <AiOutlineClose className={`absolute right-2 dark:text-slate-100 transition-colors duration-700`} size={20}></AiOutlineClose>
                        </button>
                    </div>

                    <span className={`font-sans text-sm dark:text-slate-100 transition-colors duration-700`}> Veja nossas opções de painel.</span>

                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-400 my-4 mx-1`} />

                    <div className={`border dark:border-slate-600 p-4 rounded-md`}>

                        <span className={`font-semibold dark:text-white transition-colors duration-700`}>Cores de navegação lateral</span>

                        <div className={`grid grid-cols-12`}>

                            <div className={`flex flex-row col-span-12 sm:col-span-6 mt-3 space-x-[6px]`}>
                                <button tabIndex={-1} onClick={bt_um} data-tooltip-content="Ardósia" data-tooltip-id={'btn-cor-1'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-slate-500   from-10% via-slate-700   via-30% to-slate-900   to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-slate-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_dois} data-tooltip-content="Cinza" data-tooltip-id={'btn-cor-2'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-gray-500    from-10% via-gray-700    via-30% to-gray-900    to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-gray-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_tres} data-tooltip-content="Zinco" data-tooltip-id={'btn-cor-3'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-zinc-500    from-10% via-zinc-700    via-30% to-zinc-900    to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-zinc-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_quatro} data-tooltip-content="Vermelho" data-tooltip-id={'btn-cor-4'} className={`w-6 h-6 rounded-full bg-gradient-to-br  from-red-500     from-10% via-red-700     via-30% to-red-900     to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-red-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_cinco} data-tooltip-content="Laranja" data-tooltip-id={'btn-cor-5'} className={`w-6 h-6 rounded-full bg-gradient-to-br    from-orange-500  from-10% via-orange-700  via-30% to-orange-900  to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-orange-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />

                                <ToolTips target={'btn-cor-1'} bgColor='rgb(71, 85, 105)' />
                                <ToolTips target={'btn-cor-2'} bgColor='rgb(75, 85, 99)' />
                                <ToolTips target={'btn-cor-3'} bgColor='rgb(82, 82, 91)' />
                                <ToolTips target={'btn-cor-4'} bgColor='rgb(220, 38, 38)' />
                                <ToolTips target={'btn-cor-5'} bgColor='rgb(234, 88, 12)' />

                            </div>

                            <div className={`flex flex-row col-span-12 sm:col-span-6 mt-3 space-x-[6px]`}>

                                <button tabIndex={-1} onClick={bt_seis} data-tooltip-content="Âmbar" data-tooltip-id={'btn-cor-6'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-amber-500   from-10% via-amber-700   via-30% to-amber-900   to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-amber-600' ? `  border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_sete} data-tooltip-content="Amarelo" data-tooltip-id={'btn-cor-7'} className={`w-6 h-6 rounded-full bg-gradient-to-br     from-yellow-500  from-10% via-yellow-700  via-30% to-yellow-900  to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-yellow-600' ? ` border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_oito} data-tooltip-content="Limão" data-tooltip-id={'btn-cor-8'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-lime-500    from-10% via-lime-700    via-30% to-lime-900    to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-lime-600' ? `   border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_nove} data-tooltip-content="Verde" data-tooltip-id={'btn-cor-9'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-green-500   from-10% via-green-700   via-30% to-green-900   to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-green-600' ? `  border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_dez} data-tooltip-content="Esmeralda" data-tooltip-id={'btn-cor-10'} className={`w-6 h-6 rounded-full bg-gradient-to-br   from-emerald-500 from-10% via-emerald-700 via-30% to-emerald-900 to-90%  shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-emerald-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />


                                <ToolTips target={'btn-cor-6'} bgColor='rgb(217, 119, 6)' />
                                <ToolTips target={'btn-cor-7'} bgColor='rgb(202, 138, 45)' />
                                <ToolTips target={'btn-cor-8'} bgColor='rgb(101, 163, 13)' />
                                <ToolTips target={'btn-cor-9'} bgColor='rgb(22, 163, 74)' />
                                <ToolTips target={'btn-cor-10'} bgColor='rgb(5, 150, 105)' />
                            </div>

                            <div className={`flex flex-row col-span-12 sm:col-span-6 mt-3 space-x-[6px]`}>
                                <button tabIndex={-1} onClick={bt_onze} data-tooltip-content="Verde-azulado" data-tooltip-id={'btn-cor-11'} className={`w-6 h-6 rounded-full bg-gradient-to-br  from-teal-500    from-10% via-teal-700    via-30% to-teal-900    to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-teal-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_doze} data-tooltip-content="Ciano" data-tooltip-id={'btn-cor-12'} className={`w-6 h-6 rounded-full bg-gradient-to-br          from-cyan-500    from-10% via-cyan-700    via-30% to-cyan-900    to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-cyan-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_treze} data-tooltip-content="Céu" data-tooltip-id={'btn-cor-13'} className={`w-6 h-6 rounded-full bg-gradient-to-br           from-sky-500     from-10% via-sky-700     via-30% to-sky-900     to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-sky-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_quatorze} data-tooltip-content="Azul" data-tooltip-id={'btn-cor-14'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-blue-500    from-10% via-blue-700    via-30% to-blue-900    to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-blue-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_quinze} data-tooltip-content="Índigo" data-tooltip-id={'btn-cor-15'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-indigo-500  from-10% via-indigo-700  via-30% to-indigo-900  to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-indigo-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />

                                <ToolTips target={'btn-cor-11'} bgColor='rgb(13, 148, 136)' />
                                <ToolTips target={'btn-cor-12'} bgColor='rgb(8, 145, 178)' />
                                <ToolTips target={'btn-cor-13'} bgColor='rgb(2, 132, 199)' />
                                <ToolTips target={'btn-cor-14'} bgColor='rgb(37, 99, 235)' />
                                <ToolTips target={'btn-cor-15'} bgColor='rgb(79, 70, 229)' />
                            </div>

                            <div className={`flex flex-row col-span-12 sm:col-span-6 mt-3 space-x-[6px]`}>
                                <button tabIndex={-1} onClick={bt_dezesseis} data-tooltip-content="Violeta" data-tooltip-id={'btn-cor-16'} className={`w-6 h-6 rounded-full bg-gradient-to-br   from-violet-500  from-10% via-violet-700  via-30% to-violet-900  to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-violet-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_dezessete} data-tooltip-content="Roxo" data-tooltip-id={'btn-cor-17'} className={`w-6 h-6 rounded-full bg-gradient-to-br      from-purple-500  from-10% via-purple-700  via-30% to-purple-900  to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-purple-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_dezoito} data-tooltip-content="Fúcsia" data-tooltip-id={'btn-cor-18'} className={`w-6 h-6 rounded-full bg-gradient-to-br      from-fuchsia-500 from-10% via-fuchsia-700 via-30% to-fuchsia-900 to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-fuchsia-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_dezenove} data-tooltip-content="Rosa" data-tooltip-id={'btn-cor-19'} className={`w-6 h-6 rounded-full bg-gradient-to-br       from-pink-500    from-10% via-pink-700    via-30% to-pink-900    to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-pink-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />
                                <button tabIndex={-1} onClick={bt_vinte} data-tooltip-content="Rosa-escuro" data-tooltip-id={'btn-cor-20'} className={`w-6 h-6 rounded-full bg-gradient-to-br   from-rose-500    from-10% via-rose-700    via-30% to-rose-900    to-90% shadow-lg border-2 dark:border-slate-300 ${corTema === 'bg-rose-600' ? `border-black dark:border-black` : ``} hover:border-black dark:hover:border-black transition duration-700`} />

                                <ToolTips target={'btn-cor-16'} bgColor='rgb(124, 58, 237)' />
                                <ToolTips target={'btn-cor-17'} bgColor='rgb(147, 51, 234)' />
                                <ToolTips target={'btn-cor-18'} bgColor='rgb(192, 38, 211)' />
                                <ToolTips target={'btn-cor-19'} bgColor='rgb(219, 39, 119)' />
                                <ToolTips target={'btn-cor-20'} bgColor='rgb(225, 29, 72)' />
                            </div>

                        </div>

                    </div>

                    <span className={`font-semibold pt-8 dark:text-slate-100 transition-colors duration-700`}>Modo</span>
                    <span className={`font-sans text-sm dark:text-slate-100 transition-colors duration-700`}>Escolha entre os temas claro ou escuro.</span>

                    <div className={`flex flex-row`}>
                        <button tabIndex={-1} onClick={toggleLight} className={`mt-3 mr-2 inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold  shadow-sm ring-1 ring-inset ring-slate-400 ${buttonLigth} transition-all duration-300`} >CLARO</button>
                        <button tabIndex={-1} onClick={toggleDark} className={`mt-3 ml-2 inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold  shadow-sm ring-1 ring-inset ring-slate-400  ${buttonDark} transition-all duration-300`} >ESCURO</button>
                    </div>

                    <span className={`font-semibold pt-8 dark:text-slate-100 transition-colors duration-700`}>Grade</span>
                    <span className={`font-sans text-sm dark:text-slate-100 transition-colors duration-700`}>Defina os nomes da variação e subvariação da grade produto.</span>

                    <div className={`flex flex-row relative mt-5`}>
                        <input tabIndex={-1} type="text" id="variacao" className={`${classInput} ${classInputDark} `} value={variacao} onChange={variacaoChange}></input>
                        <label htmlFor="variacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Variação</label>
                    </div>

                    <div className={`flex flex-row relative mt-5`}>
                        <input tabIndex={-1} type="text" id="subVariacao" className={`${classInput} ${classInputDark}`} value={subVariacao} onChange={subVariacaoChange}></input>
                        <label htmlFor="subVariacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>SubVariação</label>
                    </div>

                    <span className={`font-semibold pt-8 dark:text-slate-100 transition-colors duration-700`}>Taxa de Juros ao Mês</span>
                    <span className={`font-sans text-sm dark:text-slate-100 transition-colors duration-700`}>Defina a taxa de juros e quantidade de dias de espera antes de aplicar a taxa de juros.</span>

                    <div className={`flex flex-row relative mt-5`}>
                        <input tabIndex={-1} type="text" id="jurosRec" className={`${classInput} ${classInputDark} `} value={juros} onChange={jurosChange}></input>
                        <label htmlFor="jurosRec" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Juros (%)</label>
                    </div>

                    <div className={`flex flex-row relative mt-5`}>
                        <input tabIndex={-1} type="text" id="diasJurosRec" className={`${classInput} ${classInputDark} `} value={diasJuros} onChange={diasJurosChange}></input>
                        <label htmlFor="diasJurosRec" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Dias</label>
                    </div>

                    {/*
                        <span className={`font-semibold pt-8`}>Terminal</span>
                        <span className={`font-sans text-sm`}>Defina o terminal de vendas.</span>

                        <div className={`flex flex-row relative mt-3`}>
                            <input type="text" id="terminal" className={`${classInput}`} value={terminal} onChange={terminalChange}></input>
                            <label htmlFor="terminal" className={`${classLabel}`}>Terminal</label>
                        </div>
                    */}

                    <span className={`font-semibold pt-8 dark:text-slate-100 transition-colors duration-700`}>Logo</span>
                    <span className={`font-sans text-sm dark:text-slate-100 transition-colors duration-700`}>Defina a logo do menu lateral.</span>

                    <div className={`flex flex-row relative mt-3`}>

                        <input tabIndex={-1} id='inputSelectImageLogo' accept='image/jpeg,image/png' type='file' className={`hidden`} onChange={handleChangeInputImage} />
                        <button tabIndex={-1} type="button" className={`w-full h-auto p-2 mr-1  ${corHoverMenu} text-slate-600 dark:text-white hover:text-white border border-slate-600 dark:border-slate-400 hover:border-slate-200 rounded-md cursor-pointer`} onClick={handleSelectImage} >
                            {!loadingLogo ? 'Escolher Arquivo' : 'Aguarde...'}
                        </button>

                        <button tabIndex={-1} type="button" className={`w-full h-auto p-2 ml-1 ${corHoverMenu} text-slate-600 dark:text-white hover:text-white border border-slate-600 dark:border-slate-400 hover:border-slate-200 rounded-md cursor-pointer`} onClick={restaurarImagePadrao} >
                            {!loadingClearLogo ? 'Restaurar Padrão' : 'Aguarde...'}
                        </button>
                    </div>

                    <div className='flex flex-row'>
                        <button tabIndex={-1} onClick={handleSave} className={`mt-3 inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold  shadow-sm ring-1 ring-inset ring-slate-400 ${corTema} ${corHoverMenu} text-white transition-all duration-300`} >{!loading ? 'SALVAR' : 'SALVANDO . . .'}</button>
                    </div>

                </div>

            </div>

            <ModalAlert buttonConfirmClick={() => restaurarConfig()}/>

        </div>

    )

}